import { useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Download, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field = "w-full rounded-lg border border-border bg-white px-4 py-2.5 text-sm outline-none transition-colors focus:border-brand focus:ring-2 focus:ring-brand/30";

export default function LeadGateModal({ open, onOpenChange, calculator, onUnlock }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    setLoading(true);
    try {
      await axios.post(`${API}/lead-capture`, { name, email, calculator });
    } catch {
      /* never block the download on a lead-write failure */
    }
    localStorage.setItem("mfg_lead_email", email);
    localStorage.setItem("mfg_lead_name", name);
    setLoading(false);
    onOpenChange(false);
    onUnlock();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="lead-gate-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Download your results</DialogTitle>
          <DialogDescription>
            Add your name and email and your download starts right away. We'll send occasional Canadian money tips — unsubscribe anytime.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="lead-gate-name" className={field} placeholder="Full name" value={name} onChange={(e) => setName(e.target.value)} required />
          <input data-testid="lead-gate-email" type="email" className={field} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <button type="submit" data-testid="lead-gate-submit" disabled={loading}
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-action px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-action-hover disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Download className="h-4 w-4" /> Get my results</>}
          </button>
          <p className="text-center text-xs text-muted-foreground">Your calculator inputs stay in your browser — we only store your email.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
